<template>
  <div style="padding: 20px; color: #d6e6f8">
    <van-row style="padding: 13px 0px; font-size: 16px">
      <van-col :span="12">
        <van-icon name="arrow-left" size="24" @click="$router.back()" />
      </van-col>
      <van-col :span="12" class="txt-right"> </van-col>
    </van-row>
    <div class="login-title">{{ $t('register.register') }}</div>
    <van-form
      ref="frm"
      validate-first
      @submit="onSubmit"
      @failed="onFailed"
      style="margin-top: 5px"
    >
      <div style="margin-bottom: 20px">
        <div>{{ $t('register.email') }}</div>
        <van-field
          style="
            border-bottom: 1px solid #6a879d !important;
            color: #fff !important;
          "
          v-model="tmp"
          name="validatortmp"
          :placeholder="$t('register.emailplaceholder')"
          :rules="[
            { required: true },
            {
              validator: validatortmp,
              message: $t('register.emailplaceholder')
            }
          ]"
        />
      </div>
      <div style="margin-bottom: 20px">
        <div>{{ $t('other.verify_code') }}</div>
        <van-field
          v-model="frm.captcha"
          center
          clearable
          :placeholder="$t('bank.verify_code')"
          style="
            border-bottom: 1px solid #6a879d !important;
            color: #fff !important;
          "
          :rules="[{ required: true }]"
        >
          <template #button>
            <span v-if="num == 0" class="link-btn" @click="sendCode">{{
              $t('bank.sendcode')
            }}</span>
            <span v-else>{{ $t('bank.sended', { num, num }) }}</span>
          </template>
        </van-field>
      </div>
      <div style="margin-bottom: 20px">
        <div>{{ $t('other.pwd') }}</div>
        <van-field
          v-model="frm.password"
          type="password"
          style="
            border-bottom: 1px solid #6a879d !important;
            color: #fff !important;
          "
          :placeholder="$t('register.pwdplaceholder')"
          :rules="[
            { required: true },
            { validator: validatorpwd, message: $t('register.pwdplaceholder1') }
          ]"
        />
      </div>
      <div style="margin-bottom: 20px">
        <div>{{ $t('other.pwdage') }}</div>
        <van-field
          v-model="frm.repassword"
          type="password"
          style="
            border-bottom: 1px solid #6a879d !important;
            color: #fff !important;
          "
          name="validator"
          :placeholder="$t('register.agepwdplaceholder')"
          :rules="[
            { required: true },
            { validator: validator, message: $t('register.agepwdplaceholder1') }
          ]"
        />
      </div>
      <div style="margin-bottom: 20px">
        <div>{{ $t('other.invitecode') }}</div>
        <van-field
          v-model="frm.code"
          style="
            border-bottom: 1px solid #6a879d !important;
            color: #fff !important;
          "
          :placeholder="$t('register.invitecodeplaceholder')"
          :rules="[]"
          v-if="safeWapConfig.invie_code_switch == 1"
        />
      </div>
      <div>
          <van-field name="checkboxGroup">
            <template #input>
              <van-checkbox-group v-model="checkboxGroup">
                <van-checkbox name="1" shape="square" icon-size="16px"
                  ><span style="color: #6a879d !important; font-size: 16px">{{
                    $t('other.agree')
                  }}</span><span style="color: #00e6ff;" @click="show=true">《{{  $t('other.useragreement') }}》</span></van-checkbox
                >
              </van-checkbox-group>
            </template>
          </van-field>
        </div>
      <div style="margin: 16px 0">
        <van-button native-type="submit" class="web-btn"
          ><van-loading v-if="posting" /><span v-else>{{
            $t('other.registerbtn')
          }}</span></van-button
        >
      </div>
    </van-form>
    <van-row style="padding: 10px 0px; font-size: 16px">
        <van-col :span="24">
          <router-link
            class="link-btn"
            :to="'/login'"
            style="color: #6a879d !important"
            >{{ $t('other.tologin') }}</router-link
          >
        </van-col>
      </van-row>
    <van-popup v-model="show" :style="{ height: '100%', width: '100%' }">
      <div
        style="
          background-color: #092037 !important;
          color: #d6e6f8 !important;
          padding: 15px;
          position: relative;
        "
      >
        <span style="font-size: 18px; font-weight: 600">{{ $t('other.title') }}</span>
        <div style="position: absolute; right: 10px; top: 15px">
          <van-icon name="cross" size="20px" @click="show = false" />
        </div>
      </div>
      <div
        style="
          text-align: left;
          padding: 10px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 1.5;
        "
      >
        <h3 style="font-weight: 600; font-size: 18px; margin-bottom: 20px">
          {{ $t('other.h3') }}
        </h3>
        {{ $t('other.contexts') }}<br /><br />
        {{ $t('other.contexts1') }}
        <br /><br />
        {{ $t('other.contexts2') }}<br /><br />
        {{ $t('other.contexts3') }}
      </div>
    </van-popup>
  </div>
</template>

<script>
import { setToken, getToken } from '@/utils/cookies'
export default {
  name: 'RegisterView',
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  data () {
    return {
      show: true,
      tmp: null,
      num: 0,
      timer: null,
      checkboxGroup: [],
      frm: {
        email: null,
        phone: null,
        password: null,
        repassword: null,
        code: null,
        type: 2,
        captcha: null
      },
      posting: false
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    validatorpwd (val) {
      return /^[A-Za-z0-9]{6,20}$/.test(val)
    },
    validatortmp (val) {
      let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (this.frm.type != 2) {
        regex = /^\d{6,20}$/
      }
      return regex.test(val)
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true
      this.frm.email = this.tmp
      await this.$http({
        method: 'post',
        url: 'register',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          setToken(res.data.userinfo.token)
          location.reload()
        })
        .catch(() => {
          this.posting = false
        })
    },
    tabChange () {
      this.phone = null
      this.email = null
      this.$refs.frm.resetValidation()
    },
    validator (val) {
      return this.frm.password == val
    },
    onFailed (errorInfo) {
      console.log(errorInfo)
    },
    async sendCode () {
      await this.$http({
        method: 'post',
        url: 'emssend',
        data: { email: this.tmp }
      }).then((res) => {
        if(res.code == 1){
        this.num = 60
        const that = this
        this.$nextTick(() => {
          that.timer = setInterval(() => {
            if (that.num >= 0) that.num -= 1
            else {
              that.num = 0
              if (that.timer) clearInterval(that.timer)
            }
          }, 1000)
        })
      }
      })
    }
  },
  mounted () {
    if (getToken()) {
      this.$router.push({ name: "home" });
    }
    this.frm.code = this.$route.query.invite
  }
}
</script>
<style scoped>
.login-title {
  color: #d6e6f8;
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 30px;
}
</style>
